(function(){
     'use strict';

     angular
        .module('app')
        .factory('AddressService', AddressService);

    AddressService.$inject = ['$uibModal','UserService','$timeout'];

    function AddressService($uibModal,UserService,$timeout){

        var vm= {
        	countries:[],
        	address:[],
        };

        vm.addressShipping="";
      	vm.addressBilling="";
        vm.addressDirectory="";
        vm.sended = false;
        

        UserService.getCountries().then(function(data){
        	vm.countries = data.countries;
      	});

        vm.changeAddress = function(n)
        {
          console.log("CHANGE ADDRESS");
          var add;

          if(n==1){
            add = vm.loadAddress(parseInt(vm.addressShipping));
            add.iskeyaddress = 1;
          }


          if(n==2){
            add = vm.loadAddress(parseInt(vm.addressBilling));
            add.isinvoiceaddress = 1;
          }

          if(n==3){
            add = vm.loadAddress(parseInt(vm.addressDirectory));
            add.directoryaddress = 1;
          }
          if(!add)
          return ; 
        
          if( add.id > 0 ){
            vm.save(add).then(function(){
              console.log("saved");
            });
          }

        };        

        vm.getInvoiceAddress =function()
        {
          
          
        	return vm.loadAddress(parseInt(vm.addressBilling));
        };

        vm.getShippingAddress =function()
        {
          
          
          return vm.loadAddress(parseInt(vm.addressShipping));
        };

		    vm.save = function(data)
          {
            
            console.log("start save");
           return UserService.getUpdateAddress(data).then(
              function(data){
                console.log("savedpromise");

              

                  return vm.reloadAddresses().then(function(data){
                    console.log("return reloaded address");
                    console.log(data);
                    return data;

                  });
                          
                          console.log("doble click");
                         

	            });
        
          };
          
          vm.delete = function(data)
          {
           return UserService.deleteAddress(data).then(function(data){
              return vm.reloadAddresses();
            });
          };

          vm.reloadAddresses = function()
          {
            console.log("startReload");
            return UserService.getAddresses().then(function(data){
              console.log("FinishReload");
 
              vm.address = data.addresses;
              if(vm.address.length==1)
              {
                vm.addressShipping = vm.address[0].id.toString();
                vm.addressBilling = vm.address[0].id.toString();
                vm.addressDirectory = vm.address[0].id.toString();
              }
              if(vm.address.length>1){
                for (var i = 0; i < vm.address.length; i++) {
                  if(vm.address[i].isinvoiceaddress)
                     vm.addressBilling=vm.address[i].id.toString();  

                  if(vm.address[i].iskeyaddress)
                    vm.addressShipping=vm.address[i].id.toString();

                  if(vm.address[i].directoryaddress)
                    vm.addressDirectory=vm.address[i].id.toString();

                }
              }
              return data;
            });

          };
        
        
       vm.getCountryName= function(id)
      	{
          for (var i = 0; i < vm.countries.length; i++) {
            if(vm.countries[i].id==id)
            {
              return vm.countries[i].name;
            }
          }
          return "";
      	};

    	 vm.loadAddress= function(id){
          for (var i = 0; i < vm.address.length; i++) {
            if(vm.address[i].id==id)
            {
                vm.address[i].country = vm.address[i].country.toString();
                return vm.address[i];
            }

          }
            return {
                          address: "",
                          address_2:"",
                          city: "",
                          directoryaddress: 0,
                          id: 0,
                          isinvoiceaddress: 0,
                          iskeyaddress: 0,
                          zip: "",
                          country:0,
                          name:"",
                          vat:"",
                          title:"",
                          dept:""
                    };
      };

      

      //Modals
      
      vm.openAddress= function(id){

            vm.savedModal = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'address.html',
                  size: 'lg',
                  //backdrop:'static',
                  controller: function($scope) {
                    $scope.data = vm.loadAddress(id);
                    console.log($scope.data);
                    $scope.countries = vm.countries;
                    
                    $scope.saveForm = function(form){
                      if (form.$invalid) {
                          return;
                        }

                     

                          

                      if (vm.sended) {
                        return;
                      }

                      vm.sended = true;

                       vm.save($scope.data).then(function(){
                          console.log("enviado correctamente");
                        vm.savedModal.close();
                            $timeout(function(){
                              vm.sended = false;  
                        },50);
                       }
                       );                          
                    };

                    $scope.closeForm = function(){
                        vm.savedModal.close()
                        ;
                    };
                  }
              });
          };


        vm.removeModal = "";
        vm.openRemove = function(id){
            vm.removeModal = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'removeaddress.html',
                  size: 'sm',
                  //backdrop:'static',
                  controller: function($scope) {
                    $scope.data =vm.loadAddress(id);

                    $scope.countries = vm.countries;



                    $scope.deleteForm = function()
                    {
                       vm.delete($scope.data).then(function(){
                         vm.removeModal.close();
                       });
                    };
                    $scope.closeForm = function(){
                        vm.removeModal.close();
                    };
                  }
            });
          };


       return vm;

    }
})();